import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const Disc30mm = ({
	finish,
	shineAsset,
}: BadgeSVGProps) => (
	<svg 
		version="1.1" 
		id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" 
		y="0px"
		viewBox="0 0 321.7 321.7" 
		enableBackground="new 0 0 321.7 321.7" 
		xmlSpace="preserve"
	>
		<g>
			<radialGradient id="SVGID_1_" cx="160.8621" cy="160.8621" r="157.9373" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style={{ stopColor: "#072653" }} />
				<stop  offset="0.5379" style={{ stopColor: "#072551" }} />
				<stop  offset="0.7317" style={{ stopColor: "#07224A" }} />
				<stop  offset="0.8694" style={{ stopColor: "#061D3F" }} />
				<stop  offset="0.9803" style={{ stopColor: "#05162E" }} />
				<stop  offset="1" style={{ stopColor: "#05142A" }} />
			</radialGradient>
			<circle className="background-colour" fill="url(#SVGID_1_)" cx="160.9" cy="160.9" r="157.9"/>
			<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="0" y1="160.8621" x2="321.724" y2="160.8621">
				<stop  offset="0" style={{ stopColor: finish.dark }} />
				<stop  offset="0.2462" style={{ stopColor: finish.light }} />
				<stop  offset="0.4444" style={{ stopColor: finish.dark }} />
				<stop  offset="0.695" style={{ stopColor: finish.dark }} />
				<stop  offset="1" style={{ stopColor: finish.light }} />
			</linearGradient>
			<path fill="url(#SVGID_2_)" d="M318.8,160.9h-2.9c0,42.8-17.3,81.5-45.4,109.6c-28.1,28.1-66.8,45.4-109.6,45.4
				c-42.8,0-81.5-17.3-109.6-45.4C23.2,242.4,5.9,203.7,5.8,160.9c0-42.8,17.3-81.5,45.4-109.6C79.3,23.2,118,5.9,160.9,5.8
				c42.8,0,81.5,17.3,109.6,45.4c28.1,28.1,45.4,66.8,45.4,109.6H318.8h2.9C321.7,72,249.7,0,160.9,0C72,0,0,72,0,160.9
				c0,88.8,72,160.9,160.9,160.9c88.8,0,160.9-72,160.9-160.9H318.8z"
			/>
		</g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_3_" points="340.5,-15.3 -13.5,-15.3 -13.5,202.7 340.5,202.7 340.5,-15.3 			"/>
				</defs>
				<clipPath id="SVGID_4_">
					<use xlinkHref="#SVGID_3_"  overflow="visible"/>
				</clipPath>
				<g clipPath="url(#SVGID_4_)">
					<image 
						overflow="visible" 
						width="356" 
						height="220" 
						xlinkHref={shineAsset}
						transform="matrix(1 0 0 1 -14.5 -16.2758)"
					/>
					
				</g>
			</g>
		</g>
	</svg>
);
